import React from 'react';
import { ChatMessage as ChatMessageType } from '../../types/chat';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`mb-4 flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div className={`flex max-w-[80%] ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
        <div className={`flex-shrink-0 ${isUser ? 'ml-3' : 'mr-3'}`}>
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-full ${
              isUser ? 'bg-stitch-primary' : 'bg-stitch-accent'
            }`}
          >
            <span className="material-symbols-outlined text-lg text-white" style={{ fontVariationSettings: "'wght' 500" }}>
              {isUser ? 'person' : 'smart_toy'}
            </span>
          </div>
        </div>

        <div
          className={`min-w-0 break-words rounded-stitch-lg px-4 py-2 shadow-stitch-card ${
            isUser
              ? 'bg-stitch-primary text-white'
              : 'border border-stitch-border bg-stitch-surface-2 text-stitch-fg'
          }`}
        >
          <div className="text-sm">
            {message.content.split('\n').map((line, index) => (
              <div key={index}>
                {line}
                {index < message.content.split('\n').length - 1 && <br />}
              </div>
            ))}
          </div>

          {message.role === 'assistant' && message.metadata && (
            <div className="mt-3 border-t border-stitch-border pt-2">
              {message.metadata.answerScore && (
                <div className="mb-2 flex items-center">
                  <span className="mr-2 text-xs font-medium text-stitch-muted">Score:</span>
                  <div className="flex items-center">
                    <div className="rounded-stitch-md bg-stitch-primary-soft px-2 py-1 text-xs text-stitch-primary">
                      {message.metadata.answerScore}/10
                    </div>
                    {message.metadata.answerScore >= 8 && (
                      <span className="ml-2 text-xs text-stitch-success">Excellent!</span>
                    )}
                    {message.metadata.answerScore >= 6 && message.metadata.answerScore < 8 && (
                      <span className="ml-2 text-xs text-stitch-warning">Good</span>
                    )}
                    {message.metadata.answerScore < 6 && (
                      <span className="ml-2 text-xs text-stitch-danger">Needs improvement</span>
                    )}
                  </div>
                </div>
              )}

              {message.metadata.feedback && message.metadata.feedback.length > 0 && (
                <div className="mb-2">
                  <span className="text-xs font-medium text-stitch-muted">Feedback:</span>
                  <ul className="mt-1 list-inside list-disc text-xs text-stitch-fg-soft">
                    {message.metadata.feedback.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}

              {message.metadata.suggestions && message.metadata.suggestions.length > 0 && (
                <div>
                  <span className="text-xs font-medium text-stitch-muted">Suggestions:</span>
                  <ul className="mt-1 list-inside list-disc text-xs text-stitch-fg-soft">
                    {message.metadata.suggestions.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          <div className={`mt-2 text-xs ${isUser ? 'text-stitch-surface/75' : 'text-stitch-muted'}`}>
            {new Date(message.timestamp).toLocaleTimeString()}
          </div>
        </div>
      </div>
    </div>
  );
};
